let lastSelectedVariantId = null;
$(document).ready(function () {
function insertTierCard() {
    if ($('.subscription-radio.rc-radio--active').length > 0) {
      const rcWidget = document.querySelector('.custom-benefits');
      if (rcWidget && !document.querySelector('.autoship-tier-card')) {
        const offerDiv = document.createElement('div');
        offerDiv.className = 'autoship-tier-card';
        offerDiv.innerHTML = `
          <div class="tier-item">
            <img src="https://petpads.net/cdn/shop/files/image_4_7ff1304c-d37e-42d2-bdb0-990d394c6166.png">
            <div class="tier-text"><strong>First Order:</strong> 20% OFF</div>
          </div>

          <div class="tier-item">
            <img src="https://petpads.net/cdn/shop/files/image_3_71bb1948-602c-4183-8a6d-46e5d094523c.png">
            <div class="tier-text"><strong>Orders 2–3 (Bronze):</strong> 5% OFF + Extra 2% OFF</div>
          </div>

          <div class="tier-item">
            <img src="https://petpads.net/cdn/shop/files/image_1.png">
            <div class="tier-text"><strong>Orders 4–6 (Silver):</strong> 5% OFF + Extra 3% OFF + 2% PW Cash Back</div>
          </div>

          <div class="tier-item">
            <img src="https://petpads.net/cdn/shop/files/image_f27c05f8-3803-4086-a8dc-4c347f59d768.png">
            <div class="tier-text"><strong>Orders 7–9 (Gold):</strong> 5% OFF + Extra 5% OFF + 4% PW Cash Back</div>
          </div>

          <div class="tier-item">
            <img src="https://petpads.net/cdn/shop/files/image_2_1c347eb0-0385-48da-ad61-8f9316f47bb4.png">
            <div class="tier-text"><strong>Orders 10+ (VIP):</strong> 5% OFF + Extra 10% OFF + 6% PW Cash Back</div>
          </div>
        `;
        rcWidget.insertAdjacentElement('afterend', offerDiv);
      }
    } else {
      // Remove card if not active
      $('.autoship-tier-card').remove();
    }
  }

  // Run initially
  insertTierCard();
  function updatePriceState() {
    let $checked = $(".custom-varinat-input-name:checked");
    if ($checked.closest(".slideitem").hasClass("slide-item-sale")) {
      $(".price.price--large").addClass("price--on-sale");
    } else {
      $(".price.price--large").removeClass("price--on-sale");
    }
  }
  $(document).on("change", ".custom-varinat-input-name", function () {
    updatePriceState();
  });
$(document).on("change", ".onetime-radio", function () {
 setTimeout(() => {
  $('.price__container').load(window.location.href + ' .price__container > *');
     }, 200); 
 });
 function checkRadioState() {
  	if ($('.onetime-radio').hasClass('rc-radio--active')) {
       updatePriceState();
  		$("body").removeClass('sub-active');
      $("body").addClass('one-time-active');
      $(".custom-save-price-one").removeClass('hidden');
      $(".custom-save-price-autoship").addClass('hidden');

      $(".count-result-onetime").removeClass('hidden');
      $(".count-result-autoship").addClass('hidden');
  		const variantCompare = $(".custom-varinat-input-name:checked").attr("data-compareprc");
  		$("#regularsa-cut-price").text(variantCompare);
      $(".discount20_price").addClass('hidden');
  		if (!variantCompare) {
  			// $(".regularsa-cut-price").addClass("hidden");
        $(".bfcm-regular-price").removeClass("hidden");
  		} else {
  			$(".bfcm-regular-price").removeClass("hidden");
         $("body").addClass("active-campare-price");
        //  $(" price-item--regularsa").addClass("hidden");
  		}
      $(".custom-main-product .price--sold-out .price__availability, .custom-main-product .price__regular")
  			.css("display", "block");

  		$(".custom-main-product .price__sale")
  			.css("display", "none");
  	}
  	if ($('.subscription-radio').hasClass('rc-radio--active')) {
      updatePriceState();
      setTimeout(insertTierCard, 300); 
       const variantCompare = $(".custom-varinat-input-name:checked").attr("data-compareprc");
        if (!variantCompare) {
        } else {
      $("body").removeClass("active-campare-price");
        }
      $(".custom-save-price-one").addClass('hidden');
      $(".custom-save-price-autoship").removeClass('hidden');

      $(".count-result-onetime").addClass('hidden');
      $(".count-result-autoship").removeClass('hidden');
      $(".discount20_price").removeClass('hidden');
  		$("body").addClass('sub-active');
      $("body").removeClass('one-time-active');
  		$(".regularsa-cut-price").removeClass('hidden');
      $(".bfcm-regular-price").addClass("hidden");
  		$(".custom-variant-radios").addClass('active-autoship');
  		$(".custom-main-product .price--sold-out .price__availability, .custom-main-product .price__regular")
  			.css("display", "block");

  		$(".custom-main-product .price__sale")
  			.css("display", "none");
  	}
  }
  // function myStopFunction() {
  // 	clearTimeout(checkRadioState);
  // }
checkRadioState();
setInterval(checkRadioState, 300);

 setTimeout(function () {
  if ($('.rc-template__radio').length > 0) {
    }else{
   $(".count-result-autoship").addClass('hidden');
   
}
  const onetimeRadio = document.querySelector('.onetime-radio');
  if (onetimeRadio && !document.querySelector('.offer-one-sale-bfcm')) {
    const offerDiv = document.createElement('div');
    offerDiv.className = 'offer-one-sale-bfcm';
    offerDiv.innerHTML = `<span>15% LIMITED TIME DEAL</span>`;

    // Insert the div before the one-time radio label
    onetimeRadio.parentNode.insertBefore(offerDiv, onetimeRadio);
  }

 $(".count-result-onetime").removeClass('active-hidden');
    let $labelOne = $(".rc-radio.onetime-radio");
    if ($labelOne.find(".extra-discount-onetime-radio").length === 0) {
      $labelOne.find(".rc-radio__label")
        .after('<span class="extra-discount-onetime-radio"></span>');
    }
    let dis15Price = $('.custom-varinat-input-name:checked').attr('variant_discount15_price'); 
    $(".extra-discount-onetime-radio").text(dis15Price);
    let dis5Price = $('.custom-varinat-input-name:checked').attr('variant_discount5_price');
    $("#discount-percentage-inner").text(dis5Price + ' (-5%)');
    const SelectedVariantValue = $(".custom-varinat-input-name:checked").attr("data-value");
      if (SelectedVariantValue > 400) {
      if (productId === "15134852252019") {
        $(".rc-widget").show();
      } else {
        $(".rc-widget").hide();
        window.variantStrings.addToCart = "Add to Cart";
        const submitButton = document.querySelector(".custom-product-form__submit");
        const span = submitButton?.querySelector("span");
        if (span) {
          span.textContent = window.variantStrings.addToCart;
        }
        const oneTimeRadio = document.getElementById("rc-radio2");
        const hiddenOneTimeRadio = document.querySelector(
          ".rc-widget input.rc-radio__input.rc_widget__option__input--onetime"
        );
        if (oneTimeRadio) oneTimeRadio.click();
        if (hiddenOneTimeRadio) hiddenOneTimeRadio.click();
      }
    } else {
      $(".rc-widget").show();
    }
    }, 1000);
    const setSliderWidth = () => {
    const win = $('.custom-variant-picker').width();
    const newWidth = win - 70;
    $('.variantslider').css('max-width', newWidth + 'px');
  };
     setSliderWidth();
   $(window).on('resize', setSliderWidth);
   $('.custom-variant-radios').each(function () {
    const self = $(this);
    const totalWidth = self.width() - 70;
    let itemWidth = 0;

    self.find('.slideitem').each(function () {
      itemWidth += $(this).outerWidth(true);
    });
    if (itemWidth > totalWidth) {
      self.find('.custom-slide-arrows').removeClass('hidden');
    }
  });
$('span.customnext').click(function(){
    var toscroll = $(this).parents('.customslide').find('.slideitem.active').next().width();
    $(this).parents('.customslide').find('.variantslider').animate({
    scrollLeft: "+="+toscroll+"px"
  });
})
$('span.customprev').click(function(){
    var toscroll = $(this).parents('.customslide').find('.slideitem.active').next().width();
    $(this).parents('.customslide').find('.variantslider').animate({
    scrollLeft: "-="+toscroll+"px"
  });
})

const $checkedInput = $(".custom-varinat-input-name:checked");
  if ($checkedInput.length) {
    const $slideItem = $checkedInput.closest(".slideitem");
    const $variantSlider = $slideItem.closest(".variantslider");
    centerSlide($slideItem, $variantSlider);
  }

  $(".custom-varinat-input-name").click(function () {
    const $clickedInput = $(this);
    const clickedId = $clickedInput.attr("id");

    if (clickedId === lastSelectedVariantId) return;
    lastSelectedVariantId = clickedId;

    const $slideItem = $clickedInput.closest(".slideitem");
    const $customSlide = $clickedInput.parents(".customslide");
    const $variantSlider = $customSlide.find(".variantslider");

    $customSlide.find(".slideitem").removeClass("current-slide");
    $slideItem.addClass("current-slide");
    centerSlide($slideItem, $variantSlider);

    const qtyVal = $clickedInput.val();
    const qtySplitVal = qtyVal.split(" ");
    const priceVal = parseInt(qtySplitVal[0], 10);
    let productIdValue = $(".custom-varinat-input-name").attr("data-product-id");
     const variantCompare = $(".custom-varinat-input-name:checked").attr("data-compareprc");
        if (!variantCompare) {
          $("body").removeClass("active-campare-price");
        }

    if (priceVal > 400) {
      if (productIdValue === "15134852252019") {
        $(".rc-widget").show(); // Show for this specific product
      } else {
        window.variantStrings.addToCart = "Add to Cart";
        const submitButton = document.querySelector(
          ".custom-product-form__submit"
        );
        const span = submitButton?.querySelector("span");
        if (span) {
          span.textContent = window.variantStrings.addToCart;
        }
        $(".rc-widget").hide(); 

        const oneTimeRadio = document.getElementById("rc-radio2");
        const hiddenOneTimeRadio = document.querySelector(
          ".rc-widget input.rc-radio__input.rc_widget__option__input--onetime"
        );
        if (oneTimeRadio) oneTimeRadio.click();
        if (hiddenOneTimeRadio) hiddenOneTimeRadio.click();
      }
    } else {
      // Below 400: Always show the widget
      $(".rc-widget").show();
    }
    if (typeof window.updateRechargePrice === "function") {
      setTimeout(() => {
        const subRadio = document.getElementById('rc-radio1');
        if (subRadio) subRadio.removeAttribute('data-base-price');
        const originalSubChecked = subRadio?.checked;
        subRadio.checked = true;
        window.updateRechargePrice();
        subRadio.checked = originalSubChecked;
        window.updateRechargePrice();
      }, 100);
    }
  });

function centerSlide($slideItem, $variantSlider) {
    if ($slideItem.length && $variantSlider.length) {
      const slideLeft = $slideItem.position().left;
      const slideWidth = $slideItem.outerWidth(true);
      const containerWidth = $variantSlider.outerWidth();
      const containerScrollLeft = $variantSlider.scrollLeft();
      const scrollTo = containerScrollLeft + slideLeft - (containerWidth / 2) + (slideWidth / 2);

      $variantSlider.animate({ scrollLeft: scrollTo }, { duration: 150, easing: "swing" });
    }
  }
  lastSelectedVariantId = $(".custom-varinat-input-name:checked").attr("id") || null;
});

(function () {
  function updateRechargePrice() {
    const priceElement = document.querySelector('.price-item--regularsa');
    if (!priceElement) return;

    const isCustomerLoggedIn = window.customerLoggedIn === true;
    const customerTags = window.customerTags || "";
    const isSubscriber = customerTags.includes("Active Subscriber") || customerTags.includes("Inactive Subscriber");
    const shouldApplyDiscount = !isCustomerLoggedIn || !isSubscriber;

    const subRadio = document.getElementById('rc-radio1');
    const oneTimeRadio = document.getElementById('rc-radio2');
    const hiddenSubRadio = document.querySelector('.rc-widget input.rc-radio__input.rc_widget__option__input--subsave');
    const hiddenOneTimeRadio = document.querySelector('.rc-widget input.rc-radio__input.rc_widget__option__input--onetime');

if (subRadio) {
  const label = subRadio.closest('label') || document.querySelector(`label[for="${subRadio.id}"]`);
  const priceSpan = label ? label.querySelector('.rc-radio__price') : null;

  if (priceSpan) {
    const variantId = document.querySelector('.custom-varinat-input-name:checked')?.id;
    if (variantId && !subRadio.dataset[`basePrice_${variantId}`]) {
      const baseMatch = priceSpan.textContent.match(/\$?([0-9,.]+)/);
      if (baseMatch) {
        subRadio.dataset[`basePrice_${variantId}`] = parseFloat(baseMatch[1]);
      }
    }
    var labelTextOoriginal = $('.custom-varinat-input-name:checked').attr('cuspricecount');
    $(".orignal-price-data").text(labelTextOoriginal);
    
     let disPrice = $('.custom-varinat-input-name:checked').attr('variant_discount20_price');
     $(".discount20_price").text(disPrice);
    
    
      setTimeout(function () {
          let dis5Price = $('.custom-varinat-input-name:checked').attr('variant_discount5_price');
             $("#discount-percentage-inner").text(dis5Price + ' (-5%)');
        }, 300);
  
     //const basePrice = parseFloat(subRadio.dataset[`basePrice_${variantId}`]);
     let cusPrice = $('.custom-varinat-input-name:checked').attr('cuspricecount');
      $("#regularsa-cut-price").text(cusPrice);

var cusPriceSave = $('.custom-varinat-input-name:checked').attr('saved_amount');
var cusPriceSaveone = $('.custom-varinat-input-name:checked').attr('saved_amount_one');

// Handle Autoship Save Price
if (cusPriceSave && cusPriceSave.trim() !== "" && cusPriceSave !== "0" && cusPriceSave !== "0.0" && cusPriceSave !== "0.00") {
  $(".custom-save-price-autoship")
    .text('You Save $' + cusPriceSave)
    .removeClass('hiddenactive');
} else {
  $(".custom-save-price-autoship")
    .text('')
    .addClass('hiddenactive');
}

// Handle One-Time Save Price
if (cusPriceSaveone && cusPriceSaveone.trim() !== "" && cusPriceSaveone !== "0" && cusPriceSaveone !== "0.0" && cusPriceSaveone !== "0.00") {
  $(".custom-save-price-one")
    .text('You Save $' + cusPriceSaveone)
    .removeClass('hiddenactive');
} else {
  $(".custom-save-price-one")
    .text('')
    .addClass('hiddenactive');
}
    // Extra discount for black friday
    //   let extra_disPrice = $('.custom-varinat-input-name:checked').attr('variant_discount35_price'); 
    //   $(".extra-discount-radio-price").text(extra_disPrice);
    
    let extraDis15Price = $('.custom-varinat-input-name:checked').attr('variant_discount15_price'); 
    $(".extra-discount-onetime-radio").text(extraDis15Price);
     $("#bfcm-regular-price").text(extraDis15Price);
    // Get price of selected variant
    var basePrice = $('.custom-varinat-input-name:checked').attr('variant_discount_price');
 
    if (!basePrice || isNaN(basePrice)) return;
    let finalPrice = shouldApplyDiscount ? (basePrice * 0.65).toFixed(2) : basePrice;
      const priceContainer = document.querySelector('.rc-widget');
    priceSpan.textContent = `$${finalPrice}`;
    if (subRadio.checked) priceElement.textContent = `$${finalPrice}`;
    if (shouldApplyDiscount) {
      if (priceContainer && !priceContainer.querySelector('.offer-sale-bfcm')) {
        const discountDiv = document.createElement('div');
        discountDiv.className = 'offer-sale-bfcm';
        discountDiv.innerHTML = '<s>20%</s> <span><img src="https://cdn.shopify.com/s/files/1/0593/8521/7173/files/Vector_8.png"></span> 35% LIMITED TIME DEAL';
        priceContainer.prepend(discountDiv);
      }
      const subscriptionLabel = document.querySelector('.rc-radio__subscription');
      if (subscriptionLabel) subscriptionLabel.textContent = 'Autoship';
    }else{
      if (priceContainer && !priceContainer.querySelector('.offer-sale-bfcm')) {
        const discountDiv = document.createElement('div');
        discountDiv.className = 'offer-sale-bfcm';
        discountDiv.innerHTML = '<s>5%</s> <span><img src="https://cdn.shopify.com/s/files/1/0593/8521/7173/files/Vector_8.png"></span> 20% LIMITED TIME DEAL';
        priceContainer.prepend(discountDiv);
      }
      const subscriptionLabel = document.querySelector('.rc-radio__subscription');
      if (subscriptionLabel) subscriptionLabel.textContent = 'Autoship';
    }
    if (subRadio.checked && hiddenSubRadio) hiddenSubRadio.click();
  }
}

if (oneTimeRadio && oneTimeRadio.checked) {
      const label = oneTimeRadio.closest('label') || document.querySelector(`label[for="${oneTimeRadio.id}"]`);
      const priceSpan = label ? label.querySelector('.rc-radio__label') : null;

      if (priceSpan) {
        const match = priceSpan.textContent.match(/\$?([0-9,.]+)/);
        const oneTimePrice = match ? parseFloat(match[1]) : null;

        if (oneTimePrice) {
          priceElement.textContent = `$${oneTimePrice.toFixed(2)}`;
          window.baseVariantPrice = oneTimePrice;
          if (subRadio) subRadio.removeAttribute('data-base-price');
        }
        if (hiddenOneTimeRadio) hiddenOneTimeRadio.click();
      }
    }
  }
const observer = new MutationObserver((mutations, obs) => {
  const $labels = $('label.onetime-radio');
  $labels.each(function() {
    const $span = $(this).find('span.rc-radio__label');
    const fullText = $span.text().trim();
    const match = fullText.match(/^(.*?)(\$\d+(\.\d{2})?)$/);
    if (match && !$span.prev('.one-time-purchase-text').length) {
      const labelText = "One-time purchase";
      const priceText = match[2];
      $('<p class="one-time-purchase-text"></p>')
        .text(labelText)
        .insertBefore($span);
      $span.text(priceText).addClass('original-price-data');
    }
  });
    const widget = document.querySelector('.rc-widget');
    if (widget) {
      const subRadio = document.getElementById('rc-radio1');
      const oneTimeRadio = document.getElementById('rc-radio2');
      if (subRadio) subRadio.addEventListener('change', updateRechargePrice);
      if (oneTimeRadio) oneTimeRadio.addEventListener('change', updateRechargePrice);

      updateRechargePrice();
      obs.disconnect();
    }
  });
observer.observe(document.body, { childList: true, subtree: true });
  window.updateRechargePrice = updateRechargePrice;
})();